import { combineReducers } from '@reduxjs/toolkit';
import verifyFAReducer from './slices/verifyFASlice';
import activeUser from './features/activeUser/activeUser';
import { apiRegistry } from './api-register';

const apiReducers = Object.fromEntries(
  apiRegistry.map(api => [api.reducerPath, api.reducer]),
);

const rootReducer = combineReducers({
  ...apiReducers,
  activeUser,
  verifyFA: verifyFAReducer,
});

export default rootReducer;
